import client from "./client";

export const getApplyTests = (params) =>
  client.get(`/apply-test/`, {
    params,
  });
